// Galerie de vignette (« Piste 1 sans les points », validée le 2026-07-17) :
// au survol de la carte, deux flèches apparaissent sur les côtés de la photo.
// Rien n'est posé en bas de l'image : le badge « Plus que N tailles » y reste
// lisible. Un compteur discret en haut à droite signale qu'il y a d'autres
// photos (et sert d'indice sur mobile, où l'on swipe au doigt).
// Les flèches sont au-dessus du lien étiré de la carte : elles changent la
// photo sans ouvrir la fiche produit. Une seule photo = ni flèche ni compteur.
(function () {
  function init(gal) {
    var piste = gal.querySelector('.lb-gal-piste');
    if (!piste) return;
    var n = piste.children.length;
    if (n < 2) return;
    var prev = gal.querySelector('.lb-gal-fleche.prev');
    var next = gal.querySelector('.lb-gal-fleche.next');
    var compteur = gal.querySelector('[data-lb-gal-compteur]');
    var i = 0;

    function go(k) {
      i = (k + n) % n; // on boucle : jamais de flèche morte
      piste.style.transform = 'translateX(' + -i * 100 + '%)';
      if (compteur) compteur.textContent = (i + 1) + '/' + n;
    }
    go(0);

    function bouton(el, pas) {
      if (!el) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(i + pas);
      });
    }
    bouton(prev, -1);
    bouton(next, 1);

    // Retour à la photo principale quand on quitte la carte.
    var carte = gal.closest('article') || gal.parentElement;
    if (carte) carte.addEventListener('mouseleave', function () { go(0); });

    // Swipe au doigt (mobile / tablette).
    var x0 = null, w = 0;
    gal.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      x0 = e.clientX; w = gal.offsetWidth || 1; piste.style.transition = 'none';
      try { gal.setPointerCapture(e.pointerId); } catch (err) {}
    });
    gal.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var d = e.clientX - x0;
      piste.style.transform = 'translateX(' + (-i * 100 + (d / w) * 100) + '%)';
    });
    function fin(e) {
      if (x0 === null) return;
      var d = e.clientX - x0;
      x0 = null;
      piste.style.transition = '';
      if (Math.abs(d) > 40) { go(i + (d < 0 ? 1 : -1)); } else { go(i); }
    }
    gal.addEventListener('pointerup', fin);
    gal.addEventListener('pointercancel', function () { x0 = null; piste.style.transition = ''; go(i); });
  }

  function boot() {
    document.querySelectorAll('[data-lb-gal]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
